import {customAxios} from "../customAxios";
import {useState} from "react";
import {LeasePackageImportDto} from "../../model/Imports";
import {TenantUserDto, UserDto} from "../../model/Users";

export function useGetUsers() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<TenantUserDto[]>([]);
    const [error, setError] = useState<Error>();

    async function execute(tenantId: number) {
        try {
            setLoading(true);
            setError(undefined);
            const data = await getUsers(tenantId);
            setData(data);
            return data;
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {
        loading, data, error, execute
    };
}

export async function getUsers(tenantId: number): Promise<TenantUserDto[]> {
    const response = await customAxios.get<TenantUserDto[]>(`/v1/tenant/${tenantId}/users`, );
    return response.data;
}

